export const contactsData = {
    email: 'shahbazalam2002620@gmail.com',
    phone: '+91 6202040322',
    address: 'Koderma, Jharkhand, India- 825409 ',
    sheetAPI: ''
}